import { Warning } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { WOErrorTokens } from '../../common/enums/enums';
import { GenConfirmationDialog } from '../GenDialogs';

export default function WODependentServiceModal({
  selectedPrices = [],
  error,
  onCreateOrder,
  onEditServices,
  onDiscard,
}) {
  const { t } = useTranslation('global');

  const multipleServices = selectedPrices?.length > 1;
  const confirmFn = multipleServices ? onCreateOrder : onEditServices;
  const refuseFn = multipleServices ? onEditServices : onDiscard;
  const closeText = multipleServices
    ? t('woErrors.dependentService.editServices')
    : t('woErrors.dependentService.discardService');
  const confirmText = multipleServices
    ? t('woErrors.dependentService.excludeAndCreate')
    : t('woErrors.dependentService.editServices');

  const buildDependencyMessage = dependencies => {
    if (!Array.isArray(dependencies) || dependencies.length === 0) return null;

    const dependencyParts = [];
    const addPriorParts = [];

    dependencies.forEach((dep, index) => {
      const serviceName = dep.serviceName?.trim();
      const dependentNames = dep.dependencies
        ?.map(d => d.serviceName?.trim())
        .filter(Boolean);

      if (serviceName && dependentNames?.length) {
        dependencyParts.push(
          <React.Fragment key={`dep-${index}`}>
            <strong style={{ color: 'rgba(0, 0, 0, 0.60)' }}>
              {serviceName}
            </strong>{' '}
            is dependent on{' '}
            {dependentNames.map((name, i) => (
              <React.Fragment key={`depname-${index}-${i}`}>
                <strong style={{ color: 'rgba(0, 0, 0, 0.60)' }}>{name}</strong>
                {i < dependentNames.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}
          </React.Fragment>
        );

        const prefix = index === 0 ? 'please add ' : '';
        addPriorParts.push(
          <React.Fragment key={`add-${index}`}>
            {prefix}
            {dependentNames.map((name, i) => (
              <React.Fragment key={`addname-${index}-${i}`}>
                <strong style={{ color: 'rgba(0, 0, 0, 0.60)' }}>{name}</strong>
                {i < dependentNames.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}{' '}
            prior to adding{' '}
            <strong style={{ color: 'rgba(0, 0, 0, 0.60)' }}>
              {serviceName}
            </strong>
          </React.Fragment>
        );
      }
    });

    const allParts = [];

    dependencyParts.forEach((part, i) => {
      allParts.push(part);
      if (i < dependencyParts.length - 1) allParts.push(', ');
    });

    if (addPriorParts.length) {
      allParts.push(', ');
      addPriorParts.forEach((part, i) => {
        allParts.push(part);
        if (i < addPriorParts.length - 1) allParts.push(', ');
      });
      allParts.push('.');
    }

    return allParts;
  };

  const dependencyMessage = buildDependencyMessage(error?.data?.dependencies);
  return (
    <GenConfirmationDialog
      open={error?.token === WOErrorTokens.DEPENDENT_PARENT_REQUIRED}
      onClose={onDiscard}
      onRefuse={refuseFn}
      onConfirm={confirmFn}
      title={t('woErrors.dependentService.errorCreatingTitle')}
      titleIconColor={'warning'}
      closeText={closeText}
      confirmText={confirmText}
      titleIcon={Warning}
    >
      <Grid
        container
        direction={'row'}
        alignItems="center"
        justifyContent={'center'}
      >
        <span style={{ textAlign: 'center' }}>{dependencyMessage}</span>
      </Grid>
    </GenConfirmationDialog>
  );
}
